import type { UserInvestmentProfile } from '@fruitful/investment-management';

import { requestBuilder } from '../../http/RequestBuilder';

interface UseGetUserInvestmentProfileAdminParams {
    userId: string;
}

export const useGetUserInvestmentProfileAdmin = requestBuilder.query<
    UserInvestmentProfile | null,
    UseGetUserInvestmentProfileAdminParams
>({
    endpoint: ({ userId }) => `/api/admin/users/${userId}/investment-profile`,
    queryKey: ({ userId }) => `admin/user/${userId}/investment-profile`,
});
